import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface BadgeGemsProps {
  className: string
  gems: number
}

export default function BadgeGems({ className = '', gems }: BadgeGemsProps): React.ReactElement {
  const { t } = useTranslation('statistics')

  return (
    <div className={`border border-none rounded px-2 py-1 flex flex-row items-center justify-between ${className}`}>
      <ResponsiveImage alt={t('alt_texts.gems')} height={14} srcKey="icons/gem-icon.png" width={16} />
      <div className="text-xs text-center font-normal text-black-light ml-1">{gems}</div>
    </div>
  )
}
